import { IStackTokens, mergeStyles, Stack } from '@fluentui/react';
import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { getOrdersChartCountPerDate, getOrdersChartValuesPerDate } from '../../../connectors/dashboard/connectors';
import LineChartBasicExample from './LineChartBasicExample';

interface IDashboardLineChartsState {
    chartDataValuesPerDate: any;
    chartDataCountPerDate: any;
}

class DashboardLineCharts extends React.Component<WithTranslation, IDashboardLineChartsState> {
    constructor(props: any = {}) {
        super(props);
        
        this.state = {
            chartDataValuesPerDate: {
                regions: {} as any,
                general: {} as any
            },
            chartDataCountPerDate: {
                regions: {} as any,
                general: {} as any
            },
        };
    }

    private translateLegends(chartData: any): any {
        const { t } = this.props;
        const orderTypeMap: Record<string, string> = {
            "Kontener": t('orders.typeValues.container') as string,
            "Tonaż":    t('orders.typeValues.tonnage') as string,
            "Pojazd":   t('orders.typeValues.vehicle') as string,
        };
        if (!chartData || !chartData.lineChartData) return chartData;
        return {
            ...chartData,
            lineChartData: chartData.lineChartData.map((item: any) => ({
                ...item,
                legend: orderTypeMap[item.legend] || item.legend,
            })),
        };
    }

    async componentDidMount() {
        const chartDataValuesPerDate = await getOrdersChartValuesPerDate(7, []);
        const chartDataValuesPerDateRegions = await getOrdersChartValuesPerDate(7, ['0','1','2','3']);
        const chartDataCountPerDate = await getOrdersChartCountPerDate(7, []);
        const chartDataCountPerDateRegions = await getOrdersChartCountPerDate(7, ['0','1','2','3']);

        this.setState((prevState: IDashboardLineChartsState) => {
            return {
                ...prevState,
                chartDataValuesPerDate: {
                    general: this.translateLegends(chartDataValuesPerDate.data),
                    regions: this.translateLegends(chartDataValuesPerDateRegions.data),
                },
                chartDataCountPerDate: {
                    general: this.translateLegends(chartDataCountPerDate.data),
                    regions: this.translateLegends(chartDataCountPerDateRegions.data),
                },
            };
        });
    }

    public render(): JSX.Element {
        const { t } = this.props;
        const { chartDataValuesPerDate, chartDataCountPerDate } = this.state;
        const stackWithTopBorder = mergeStyles({
            marginRight: 44,
            paddingTop: 25,
            borderTop: '1px solid rgba(128,128,128, 0.25)',
        });
        const sectionStackTokens: IStackTokens = { childrenGap: 40 };

        const legendsOverflowText = t("dashboard.legendsOverflow") as string;

        return <>
            <Stack horizontal tokens={sectionStackTokens} className={stackWithTopBorder}>
                <LineChartBasicExample lineChartData={chartDataValuesPerDate.regions.lineChartData} lineChartTitle={t("dashboard.chartValuesRegion") as string} legendsOverflowText={legendsOverflowText} />
                <LineChartBasicExample lineChartData={chartDataCountPerDate.regions.lineChartData} lineChartTitle={t("dashboard.chartCountRegion") as string} legendsOverflowText={legendsOverflowText} />
            </Stack>

            <Stack horizontal tokens={sectionStackTokens} className={stackWithTopBorder}>
                <LineChartBasicExample lineChartData={chartDataValuesPerDate.general.lineChartData} lineChartTitle={t("dashboard.chartValuesGeneral") as string} legendsOverflowText={legendsOverflowText} />
                <LineChartBasicExample lineChartData={chartDataCountPerDate.general.lineChartData} lineChartTitle={t("dashboard.chartCountGeneral") as string} legendsOverflowText={legendsOverflowText} />
            </Stack>
        </>;
    }
}

export default withTranslation("admin")(DashboardLineCharts);